import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/Table';
import { Badge } from '@/components/ui/Badge';
import { Button } from '@/components/ui/Button';
import { Edit, Trash2 } from 'lucide-react';
import type { CreditPlan } from '../hooks/useCreditPlans';

interface CreditPlanTableProps {
  plans: CreditPlan[];
  onEdit: (plan: CreditPlan) => void;
  onDelete: (planId: number) => void;
}

export const CreditPlanTable: React.FC<CreditPlanTableProps> = ({
  plans,
  onEdit,
  onDelete,
}) => {
  const getBillingTypeLabel = (plan: CreditPlan) => {
    const monthlyBase = Number(plan.monthly_base ?? 0);
    const per = Number(plan.price_per_unit ?? 0);
    if (monthlyBase === 0 && per === 0) return '무료 플랜';
    if (monthlyBase === 0 && per > 0) return '이용횟수당';
    if (monthlyBase > 0 && per === 0) return '월정액';
    if (monthlyBase > 0 && per > 0) return '월정액+이용횟수당';
    return '커스텀';
  };

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>ID</TableHead>
          <TableHead>플랜 이름</TableHead>
          <TableHead>과금 유형</TableHead>
          <TableHead>월 기본 요금</TableHead>
          <TableHead>단위당 가격</TableHead>
          <TableHead>상태</TableHead>
          <TableHead>작업</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {plans.map((plan) => (
          <TableRow key={plan.id}>
            <TableCell className="text-sm text-gray-600">
              {plan.id}
            </TableCell>
            <TableCell className="font-medium">{plan.plan_name}</TableCell>
            <TableCell className="text-sm text-gray-700">
              {getBillingTypeLabel(plan)}
            </TableCell>
            <TableCell>
              <span className="font-semibold text-blue-600">
                {Number(plan.monthly_base ?? 0).toFixed(1)}
              </span>
              <span className="text-gray-500 ml-1">크레딧</span>
            </TableCell>
            <TableCell>
              <span className="font-semibold text-blue-600">
                {Number(plan.price_per_unit ?? 0).toFixed(1)}
              </span>
              <span className="text-gray-500 ml-1">크레딧</span>
            </TableCell>
            <TableCell>
              <Badge variant={plan.is_active ? 'active' : 'inactive'}>
                {plan.is_active ? '활성' : '비활성'}
              </Badge>
            </TableCell>
            <TableCell>
              <div className="flex gap-2">
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => onEdit(plan)}
                >
                  <Edit className="h-4 w-4" />
                </Button>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => onDelete(plan.id)}
                >
                  <Trash2 className="h-4 w-4" />
                </Button>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

